import React from 'react'
import { Row, Col } from 'antd'
import { Back } from 'components/Locations/AvailabilityRules/commonStyles'
import { IoArrowBack } from 'react-icons/io5'
import styled from '@emotion/styled'

interface CommonHeaderProps {
  title: string
  onBack: () => void
  helpLink: string
}

const CommonHeader = ({ title, onBack, helpLink }: CommonHeaderProps) => {
  return (
    <Row justify='space-between' className='_mb-0 _mt-4'>
      <Col>
        <Back
          onClick={onBack}
          style={{
            justifyContent: 'space-between'
          }}
        >
          <IoArrowBack size='20' /> <span>{title}</span>
        </Back>
      </Col>
      <Col>
        <Help>
          Need help? <Text>Visit our</Text>{' '}
          <Link href={helpLink} target='_blank' rel='noopener noreferrer'>
            help centre
          </Link>
        </Help>
      </Col>
    </Row>
  )
}

const Help = styled.span`
  font-size: 16px;
  font-weight: 600;
`

const Text = styled.span`
  font-size: 16px;
  font-weight: 400;
`

const Link = styled.a`
  color: #d092dd;
  text-decoration: underline;

  &:visited,
  &:active,
  &:focus,
  &:hover {
    color: #d092dd;
    text-decoration: underline;
  }
`

export default CommonHeader
